export default __webpack_public_path__ + "static/media/Al Fattah Al Aleem.dfae0dcb.svg";